import {
  Outlet,
  createFileRoute,
  redirect,
} from '@tanstack/react-router'

const UnAuthLayout = () => {

  return (
    <Outlet />
  )
}

export const Route = createFileRoute('/_unauth')({
  beforeLoad: ({ context }) => {
    if (context.auth?.isAuthenticated) {
      // Eğer lastVisitedPage varsa oraya yönlendir, yoksa /users'a
      const lastVisitedPage = localStorage.getItem("lastVisitedPage")

      if (lastVisitedPage && lastVisitedPage !== "/" && lastVisitedPage !== "/login") {
        throw redirect({
          to: lastVisitedPage,
        })
      } else {
        throw redirect({
          to: "/users",
        })
      }
    }
  },
  component: UnAuthLayout,
})

